(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('brandInfo', ["$q", "configDao", function ($q, configDao) {
        var initialized = false;
        var brandLabel = 'Avanan';
        var brand = 'avanan';
        var topDomain = 'avanan.net';
        var portalUrl = '';
        var sonicwallDefaultPortalUrl = 'https://www.mysonicwall.com/';
        var checkpointDefaultPortalUrl = 'https://portal.checkpoint.com/Dashboard/CloudGuardSaaS/ThreatProtection';
        var appNames = {
            'Smart-Phish': {
                checkpointTheme: 'Anti-Phishing',
                sonicwallTheme: 'Anti-Phishing'
            }
        };
        function getConfigParams() {
            $q.allSettled([
                configDao.param('brand_name'),
                configDao.param('top_domain'),
                configDao.param('brand'),
                configDao.getPortalUrlConfig()
            ]).then(function (responses) {
                console.log('brandInfo:', responses);
                if (responses[0].value) {
                    brandLabel = responses[0].value;
                }
                if (responses[1].value) {
                    topDomain = responses[1].value;
                }
                if (responses[2].value) {
                    brand = responses[2].value;
                }
                if (responses[3].value && responses[3].value.data) {
                    portalUrl = responses[3].value.data;
                }
                initialized = true;
                return $q.when();
            });
        }
        var utilities = {
            init: function () {
                if (!initialized) {
                    return getConfigParams();
                }
                return $q.when();
            },
            getBrandLabel: function () {
                return brandLabel;
            },
            getTopDomain: function () {
                return topDomain;
            },
            getCustomerDomain: function () {
                var hostArr = window.location.hostname.split('.' + topDomain);
                return hostArr[0];
            },
            customerSubdomain: function () {
                var subdomain = '.avanan.net';
                if (window.location.hostname.indexOf('.checkpointcloudsec.com') !== -1) {
                    subdomain = '.checkpointcloudsec.com';
                } else if (window.location.hostname.indexOf('.sonicwallcloudsec.com') !== -1) {
                    subdomain = '.sonicwallcloudsec.com';
                }
                var hostname = window.location.hostname.split(subdomain);
                return hostname[0];
            },
            appendPortalToCustomerDomain: function () {
                var subdomain = '.avanan.net';
                var windowHostname = window.location.hostname;
                if (windowHostname.indexOf('.checkpointcloudsec.com') !== -1) {
                    subdomain = '.checkpointcloudsec.com';
                } else if (windowHostname.indexOf('.sonicwallcloudsec.com') !== -1) {
                    subdomain = '.sonicwallcloudsec.com';
                } else if (windowHostname.indexOf('.avanan-dev.net') !== -1) {
                    subdomain = '.avanan-dev.net';
                }
                var hostname = windowHostname.split(subdomain);
                if (hostname[0].endsWith('-v1')) {
                    hostname[0] = hostname[0].replace('-v1', '');
                }
                if (!hostname[0].endsWith('-portal')) {
                    hostname[0] = hostname[0] + '-portal';
                }
                hostname.splice(1, 0, subdomain);
                var joinedHostname = hostname.join('');
                var appRoute = window.location.href.split('/new.html#!/')[1];
                return joinedHostname;
            },
            getPortalUrl: function (theme) {
                if (!portalUrl) {
                    if (theme === 'cp') {
                        return checkpointDefaultPortalUrl;
                    } else if (theme === 'sw') {
                        return sonicwallDefaultPortalUrl;
                    }
                }
                return portalUrl;
            },
            getBrand: function () {
                return brand;
            },
            getAppName: function (name, theme) {
                return appNames[name][theme];
            }
        };
        return utilities;
    }]);
}());